// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { PAYMENT_METHOD } from './../../../types/next/blocks/paymentMethodBlock'
import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'

export const paymentMethodSchema = z.nativeEnum(PAYMENT_METHOD)

export const sEPASettingsSchema = z.object({
  fieldLabels: z
    .object({
      accountOwner: z.string().optional(),
      bankName: z.string().optional(),
      consentLabel: z.string().optional()
    })
    .optional(),
  accountNumberValidationURL: z.string()
})

export const iPaymentMethodSchema = z.object({
  type: paymentMethodSchema,
  label: z.string()
})

export const bankTransferSchema = iPaymentMethodSchema.extend({
  type: z.literal(PAYMENT_METHOD.BANK_TRANSFER)
})

export const sepaSchema = iPaymentMethodSchema.extend({
  type: z.literal(PAYMENT_METHOD.SEPA),
  settings: sEPASettingsSchema
})

export const anyPaymentMethodSchema = z.union([bankTransferSchema, sepaSchema])

export const paymentMethodBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.PAYMENT_METHOD),
  settings: blockBaseSettingsSchema.and(
    z.object({
      inputUIPattern: z.string(),
      preselectedMethod: paymentMethodSchema.optional(),
      implementations: z.array(anyPaymentMethodSchema)
    })
  )
})

export const iPaymentMethodBlockValueSchema = z.object({
  type: z.union([z.literal('payment_invoice'), z.literal('payment_sepa')]),
  label: z.string().optional()
})

export const bankTransferPaymentMethodValueSchema =
  iPaymentMethodBlockValueSchema.extend({
    type: z.literal('payment_invoice')
  })

export const sEPAPaymentMethodValueSchema =
  iPaymentMethodBlockValueSchema.extend({
    type: z.literal('payment_sepa'),
    data: z
      .object({
        fullname: z.string().optional(),
        iban: z.string().optional(),
        consent: z.boolean().optional(),
        bic_number: z.string().optional(),
        bank_name: z.string().optional()
      })
      .optional()
  })

export const paymentMethodBlockValueSchema = z.union([
  bankTransferPaymentMethodValueSchema,
  sEPAPaymentMethodValueSchema
])
